import { SVGProps } from "react";

const VSCDebugContinueSmall = (props: SVGProps<SVGSVGElement>) => <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4 2H3V14H4V2ZM7.29062 2.59314L6.5 3.00001V13L7.29062 13.4069L14.2906 8.40687V7.59314L7.29062 2.59314ZM13.1398 8.00001L7.5 12.0284V3.9716L13.1398 8.00001Z" /></svg>;

export { VSCDebugContinueSmall };